// ai创作相关接口
import request from '@/utils/http.js';

// 获取概要总结信息
const getSummaryInfo = (params = {}) => {
  let url = '/v3/ai/video/summary-info';

  return request({
    url: url,
    method: 'GET',
    params: params
  });
};


/**
 * 观看端聚合接口
 * 获取内容包括：
 *  智能字幕、字幕样式、精彩时刻、概要总结
 * @param {*} params 
 * @returns 
 */
const getAiUnionInfo = (params = {}) => {
  let url = '/v3/ai/video/watch-union';
  return request({
    url: url,
    method: 'GET',
    params: params
  });
};

const aiApi = {
  getSummaryInfo,
  getAiUnionInfo
};


export default aiApi;
